<template>
  <div class="content-box">

    <div class="sub-catalog">
        <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首頁</el-breadcrumb-item>
                <el-breadcrumb-item>海關論壇</el-breadcrumb-item>
                <el-breadcrumb-item>論壇題目</el-breadcrumb-item>
        </el-breadcrumb>
    </div>
    <div class="sub-line"></div>



    <div class="content">
          <div class="row1">
            <div class="talk-title">{{talkinfo.talktitle}}</div>
            <div class="author-time">
                <div>作者：<span>測試用戶</span></div>
                <div>時間：<span>{{talkinfo.talktime}}</span></div>
            </div>
          </div>
          <div class="row2">
              <div>
                  <span>{{talkinfo.talkcontent}}</span>
              </div>
          </div>


          <div class="row3">
              <div class="row3-row1">
                  <div class="row3-1-pl">評論</div>
                  <div class="row3-1-img"><img src="../assets/icon/line.png" alt=""></div>
              </div>
              <div class="row3-row2">
                  <div class="row2-2-box">
                      <textarea class="row2-2-box-c" v-model="pl"  name="" id="" cols="30" rows="10"></textarea>
                      <el-button @click="sendpl" class="row2-2-btn">提交</el-button>
                  </div>
              </div>
              <div v-for="(item,index) in answerlist" :key="index"  :value="item.ID" class="row3-row3">
                  <div class="row3-row3-row">
                        <div class="row3-row3-title-row1">
                            <div class="row3-3-xh">{{index+1}}</div>
                            <div class="row3-3-yh">{{item.userid}}</div>
                            <div class="row3-3-time">{{item.talktime}}</div>
                        </div>
                        <div class="row3-row3-title-row2">
                            <div>
                                <div><li class="el-icon-chat-dot-square"></li></div><span>回復</span>
                            </div>
                            <div>
                                <div><li class="el-icon-thumb"></li></div><span>81</span>
                            </div>
                        </div>
                        
                    </div>
                    <div class="row3-row3-contet">{{item.talkcontent}}</div>
              </div>

          </div>




    </div>
  </div>
</template>


<script>
export default {
  name: "app",
  data() {
    return {
      //totaldata:'99999',
      activeIndex:this.$route.query.aIndex,
      talkinfo:'',//论坛详情
      answerlist:'',//评论列条
      tid:0,
      pl:"",
      
    };
  },
  methods: {
      //提交论坛评论内容
      sendpl(){
          if(this.pl==""){
              this.$notify.info({
                title: '溫馨提示',
                message: '請填寫內容'
                });
              return;
          }
          let uid=window.sessionStorage.getItem("hguid");
          let uname=window.sessionStorage.getItem("hguser");
          this.$http
            .get(`${this.$store.state.baseurl}/api/hgtalkfun/addtalk?tid=`+this.tid+'&uid='+uid+'&msg='+this.pl)
            .then((res) => {
                this.$notify({
                    title: '成功',
                    message: '內容提交成功！',
                    type: 'success'
                    });
            });
            this.$router.go(0);
      },
    
  },
  created() {
    //this.sourceurl=`${this.$store.state.sourceurl}../..`;
    this.tid=this.$route.query.id;
    this.$http
      .get(`${this.$store.state.baseurl}/api/hgtalk/gettalkinfo?id=`+this.tid)
      .then((res) => {
        const json = res.data;
        let pinfo=JSON.parse(json);
        this.talkinfo=pinfo.data[0];
        this.answerlist=pinfo.data2;
        
      });
    
  },
};
</script>



<style scoped lang="scss">
.content-box {
    display: flex;
    flex-direction: column;
    min-height:600px;
    width: 100%;
    background-color: #e5e2db;
    border-width: 0px 0px 1px 0px ;
	border-style: solid;
	border-color:#cec0b2;
    
}
.sub-catalog{
  width: 1220px;
  margin-left: auto;
  margin-right: auto;
  text-align: left;
  font-size: 14px;
  color: #666666;
  padding-top: 14px;
  padding-bottom: 14px;
  
}
.sub-line{
  border-width: 0px 0px 1px 0px ;
	border-style: solid;
	border-color:#cec0b2;
}
.content {
  width: 1220px;
  margin-left: auto;
  margin-right: auto;
  text-align: left;
  .row1{
        border-width: 0px 0px 1px 0px ;
        border-style: dotted;
        border-color:#cec0b2;
        width: 1220px;
        .talk-title{
            padding: 15px 25px 0px 25px;
            text-align: left;
            font-size: 20px;
            font-weight: 600;
        }
        .author-time{
            display: flex;
            flex-direction: row;
            justify-content: start;
            flex-wrap: wrap;
            color: #333333;
            div{
                padding: 15px 25px;
            }
        }
     }

     .row2{
         min-height: 300px;
         padding: 25px 25px;
         
     }

     .row3{
         padding: 25px 25px;
         .row3-row1{
             display: flex;
            flex-direction: row;
            justify-content: start;
            flex-wrap: wrap;
            .row3-1-pl{
                font-size: 18px;
                color: #333333;
            }
            .row3-1-img{
                padding-top: 5px;
            }
         }
         .row3-row2{
             
            .row2-2-box{
                display: flex;
                flex-direction: row;
                justify-content: start;
                flex-wrap: wrap;

                .row2-2-box-c{
                    width: 800px;
                    margin: 20px;
                    border: 0;
                    border-radius: 10px;
                    padding: 10px;

                }
                .row2-2-btn{
                    margin-top:140px;
                    height:40px;
                    
                    

                }

            }
         }
         .row3-row3{
            .row3-row3-row{
                display: flex;
                flex-direction: row;
                justify-content: start;
                flex-wrap: wrap;
                .row3-row3-title-row1{
                    display: flex;
                    flex-direction: row;
                    justify-content: start;
                    flex-wrap: wrap;
                    width: 900px;
                    .row3-3-xh{
                        padding: 10px 20px;
                        color: #333333;
                    }
                    .row3-3-yh{
                        padding: 10px 20px;
                        font-weight: 600;
                    }
                    .row3-3-time{
                        padding: 10px 20px;
                    }

                }
                .row3-row3-title-row2{
                    display: flex;
                    flex-direction: row;
                    justify-content: start;
                    flex-wrap: wrap;
                    div{
                        display: flex;
                        flex-direction: row;
                        justify-content: start;
                        flex-wrap: wrap;
                        padding: 5px 10px;
                        div{
                            li{
                                font-size: 20px
                            }

                        }
                        span{
                            padding:5px 5px;
                        }
                    }

                }
                
            }
            .row3-row3-contet{
                font-size: 14px;
                padding:10px 30px;

            }
         }
         
     }
        
  
}






</style>